import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { Fade } from '@material-ui/core';
import { useAppContext } from 'contexts/AppContext';
import defaultLocales from 'globals/locales/default';
import { isSuccessState } from 'globals/utils';
import FsPaper from 'ui-elements/main-elements/FsPaper';
import FsDefaultFallbackComponent from 'ui-elements/loaders/FsDefaultFallbackComponent';
import PaymentMethodModal from '../BillingsModals/PaymentMethodModal';
import {
  ButtonWrapperBox,
  ContentBox,
  Paragraph,
  ActionButton,
} from './PaymentMethod.style-elements';
import CardNumberPlaceholder from './CardNumberPlaceholder';

const PaymentMethod: React.FC = () => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const {
    isPaymentMethodIssue,
    paymentMethod: { status, getPaymentDetailsSnapshot, init: initStore },
  } = useAppContext();
  const { ccName } = getPaymentDetailsSnapshot();

  useEffect(() => {
    initStore();
  }, [initStore]);

  if (!isSuccessState(status))
    return (
      <FsDefaultFallbackComponent
        status={status}
        data-test="default-fallback-component"
      />
    );

  return (
    <>
      <Fade in timeout={1000}>
        <FsPaper
          title={defaultLocales.paymentMethod}
          severity="error"
          alertContent={
            isPaymentMethodIssue
              ? defaultLocales.wrongCreditCardAlertInfo
              : undefined
          }
        >
          <ContentBox>
            <Paragraph>{ccName}</Paragraph>
          </ContentBox>
          <CardNumberPlaceholder />
          <ButtonWrapperBox>
            <ActionButton onClick={() => setShowModal(true)}>
              {defaultLocales.changeCreditCard}
            </ActionButton>
          </ButtonWrapperBox>
        </FsPaper>
      </Fade>

      <PaymentMethodModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
      />
    </>
  );
};

export default observer(PaymentMethod);
